function applyAttributes(listItems, attributeList) {
    if (!listItems || listItems.length === 0) {
        return null;
    }
    listItems.forEach(item => {
        attributeList.forEach(attribute => {
            const { name, setter } = attribute;
            const object = item.constructorList.find(obj => obj.field === name);
            if (object && setter) {
                setter(object.argument);
            }
        });
    });
}

export default { applyAttributes };
